export function formatFriendlyDate(date: Date): string {
  const now = new Date();

  // Zera as horas para comparar apenas a data (sem considerar hora/min/segundos)
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);

  const inputDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  );

  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');

  if (inputDate.getTime() === today.getTime()) {
    return `Hoje às ${hours}:${minutes}`;
  }
  if (inputDate.getTime() === yesterday.getTime()) {
    return `Ontem às ${hours}:${minutes}`;
  }
  // Caso queira tratar como erro ou outra mensagem para datas mais antigas
  return `${date.toLocaleDateString()} às ${hours}:${minutes}`;
}
